import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import React, { Component } from 'react';
import i18n from '../../i18n';
import { HistoricoAceiteLGPD } from '../../service/HistoricoAceiteLGPD';
import { LGPDContentPtBR } from './LGPD.pt-BR';
import { LGPDContentEnUS } from './LGPD.en-US';
import { LGPDContentEsCL } from './LGPD.es-CL';

const lgpdContentByLanguage = {
    'pt-BR': LGPDContentPtBR,
    'en-US': LGPDContentEnUS,
    'es-CL': LGPDContentEsCL
};

const normalizeLanguage = (language) => {
    if (!language) return 'pt-BR';

    if (lgpdContentByLanguage[language]) return language;

    const languagePrefix = language.split('-')[0];
    const languageMap = {
        pt: 'pt-BR',
        en: 'en-US',
        es: 'es-CL'
    };

    return languageMap[languagePrefix] || 'pt-BR';
};

export class ScreensLGPDForm extends Component {

    cancelarLGPD() {
        sessionStorage.clear();
        window.location.reload();
    }

    aceitarLGPD() {
        const historicoAceiteLGPD = new HistoricoAceiteLGPD();
        historicoAceiteLGPD.PostHistoricoAceiteLGPD(this.props.objLGPD.Usuario);
    }

    getSelectedLanguage() {
        const storedLanguage = typeof localStorage !== 'undefined'
            ? localStorage.getItem('appLang')
            : null;

        return normalizeLanguage(storedLanguage || i18n.language);
    }

    renderLGPDContent() {
        const Content = lgpdContentByLanguage[this.getSelectedLanguage()] || LGPDContentPtBR;

        return <Content />;
    }

    render() {
        return (
            <div>
                <Dialog
                    id="dialogLGPD"
                    visible={this.props.objLGPD.Exibir}
                    style={{ width: '95%', height: '95%', zIndex: 600 }}
                    closable={false}
                    className="lgpd-modal"
                    footer={
                        <div className="lgpd-modal__buttons">
                            <Button label={i18n.t("PORTAL.BUTTON.CANCEL")} icon="pi pi-times" className="lgpd-modal__button--cancel p-button-text p-button-danger" onClick={() => this.cancelarLGPD()} />
                            <Button label={i18n.t("PORTAL.BUTTON.ACCEPT")} icon="pi pi-check" className="lgpd-modal__button--accept p-button-primary" onClick={() => this.aceitarLGPD()} />
                        </div>
                    }
                >
                    <div className="lgpd-modal__text">
                        {this.renderLGPDContent()}
                    </div>
                </Dialog>
            </div>
        );
    }
}
